import { Link as ReactLink, useLocation } from "react-router-dom";
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Icon, Link, List, ListItem } from "@chakra-ui/react";

interface Props {
  minimize: boolean;
  title: string;
  link: string;
  icon: React.ReactNode;
  subMenu?: Array<{
    title: string;
    link: string;
    icon: React.ReactNode;
  }>;
}

// const location = useLocation().pathname;
function SidebarItem({ minimize, title, link, icon, subMenu }: Props) {
  const location = useLocation().pathname;
  const isActiveSubItem = subMenu?.some((item) => location === item.link);

  return (
    <Accordion allowToggle width="100%">
      <AccordionItem border="none">
        <Link as={ReactLink} to={link}>
          <AccordionButton style={{ ...styles.accordionButton, justifyContent: minimize ? "center" : "space-between" }} sx={{ bg: isActiveSubItem ? "#1A365D" : "none", "&:hover": { bg: "#1A365D" } }}>
            <div style={styles.accordionLabel}>
              <div style={{ marginBottom: 5 }}>{icon ?? <Icon />}</div>
              {!minimize && <div>{title}</div>}
            </div>
            {!minimize && subMenu && <AccordionIcon />}
          </AccordionButton>
        </Link>

        {subMenu && <AccordionPanel>
          <List style={{ paddingLeft: 30 }}>
            {subMenu.map((item, index) => (
              <ListItem key={index} sx={{ color: location === item.link ? "black" : "white", "&:hover": { color: "black"} }}>
                <Link as={ReactLink} to={item.link} _hover={{ textDecoration: "none" }}>
                  <div style={styles.accordionLabel}>
                    <div style={{ marginBottom: 5 }}>{item.icon ?? <Icon />}</div>
                    <div>{item.title}</div>
                  </div>
                </Link>
              </ListItem>
            ))}
          </List>
        </AccordionPanel>}
      </AccordionItem>
    </Accordion>
  );
}

const styles: { [key: string]: React.CSSProperties } = {
  accordionButton: {
    display: "flex",
    alignItems: "center",
    color: "white",
  },
  accordionLabel: {
    display: "flex",
    alignItems: "center",
    padding: "10px 0",
    gap: "15px",
  },
};

export default SidebarItem;
